import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Container } from 'reactstrap';
import { defineMessages } from 'react-intl';

import Page from '../../components/layout/Page';
import GenericLayout from '../../components/layout/GenericLayout';
import SEOTitle from '../../components/head/SEOTitle';
import RobotsMeta from '../../components/head/RobotsMeta';
import ThankYouPageContent from '../../components/checkout/ThankYouPageContent';
import TrackingEventType from '../../types/TrackingPageType';
import { modelOf } from '../../prop-types';
import TrackingStore from '../../store/TrackingStore';
import ConfigStore from '../../store/ConfigStore';
import CommonPage from '../../types/CommonPage';

const messages = defineMessages({
  successfulPurchasePageTitle: {
    id: 'checkout.successfulPurchasePageTitle',
    defaultMessage: 'Your order has been registered!'
  }
});

@observer
class ThankYouPage extends Component {
  sendTrackingData = (currentOrder) => {
    const { trackingStore, configStore } = this.props;

    if (
      !configStore.activateSpotmore.enabled ||
      typeof document === 'undefined' ||
      !currentOrder ||
      currentOrder.is_seen
    ) {
      return null;
    }

    if (configStore.activateSpotmore.enabled && window.crmtracker) {
      window.crmtracker.sendData();
    }

    trackingStore.setPageView({
      page: TrackingEventType.CHECKOUT_SUCCESS,
      refererUrl: document.referrer,
      visitedUrl: window.location.href
    });
    trackingStore.postPageView();
  };

  render() {
    return (
      <Page
        name={CommonPage.CHECKOUT_SUCCESS}
        className="ThankYouPage"
        onDefinedTrackingPage={TrackingEventType.CHECKOUT_SUCCESS}
      >
        <Container className="ThankYouPage__container">
          <GenericLayout
            content={
              <Fragment>
                <SEOTitle title={messages.successfulPurchasePageTitle} />
                <RobotsMeta noindex />
                <ThankYouPageContent onOrderSuccess={this.sendTrackingData} />
              </Fragment>
            }
          />
        </Container>
      </Page>
    );
  }
}

ThankYouPage.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  trackingStore: modelOf(TrackingStore).isRequired
};

export default inject('configStore', 'trackingStore')(ThankYouPage);



// WEBPACK FOOTER //
// ./src/pages/ThankYouPage/index.jsx